const l = {
  language: "English",

  "app.error": "Error",
  "app.close": "Close",
  "app.start": "Start",
  "app.noConversations": "No conversations yet",
  "app.conversation": "Conversation",
  "app.conversations": "Conversations",
  "app.loading": "Loading...",
  "app.tryAgain": "Please try again",
  "app.signOut": "Sign Out",
  "app.next": "Next",
  "app.previous": "Previous",
  "app.finish": "Finish",
  "app.cancel": "Cancel",
  "app.restart": "Restart",

  "layout.unableToConnect": "Unable to connect to server",
  "layout.home": "Home",
  "layout.chat": "Daily Session",
  "layout.wordbook": "Wordbook",
  "layout.pronunciation": "Pronunciation",
  "layout.progress": "Progress",
  "layout.programs": "Programs",
  "layout.settings": "Settings",
  "layout.hub": "Learning Hub",
  "layout.account": "Account",
  "layout.manageAccount": "Manage Account",
  "layout.leaveReview": "Leave a Review",
  "layout.parentServiceLink": "Back to {name}",
  "layout.practiceTools": "Practice Tools",

  "home.practiceByTopic.title": "Practice by Topic",
  "home.practiceByTopic.description": "Choose a situation or context you want to improve in.",

  "dashboard.title": "Home",
  "dashboard.subtitle": "Pick your path and keep progressing",
  "dashboard.learningStreaks.title": "Learning Streaks",
  "dashboard.learningStreaks.description":
    "Track your progress and maintain a consistent learning habit",
  "dashboard.learningStreaks.dayStreak": "Day streak",
  "dashboard.learningStreaks.longestStreak": "Longest streak",
  "dashboard.learningStreaks.conversations": "Conversations",
  "dashboard.learningStreaks.globalRanking": "Global Ranking",
  "dashboard.learningStreaks.topPercentage": "Top {percentage}%",
  "dashboard.learningStreaks.globalRankingExplanation":
    "Speak to the tutor to unlock your placement.",

  "dashboard.learningStreaks.achievement1": "Starting the journey",
  "dashboard.learningStreaks.achievement3": "Three days of consistency",
  "dashboard.learningStreaks.achievement4": "Four days of consistency",
  "dashboard.learningStreaks.achievement5": "A solid five-day streak",
  "dashboard.learningStreaks.achievement6": "A solid six-day streak",
  "dashboard.learningStreaks.achievement7": "A week of learning",
  "dashboard.learningStreaks.achievement8": "More than a week of learning",
  "dashboard.learningStreaks.achievement10": "Double digits!",
  "dashboard.learningStreaks.achievement14": "Two weeks of knowledge",
  "dashboard.learningStreaks.achievement20": "Hitting the 20-day mark",
  "dashboard.learningStreaks.achievement25": "Quarter of a century!",
  "dashboard.learningStreaks.achievement30": "A month of dedication",
  "dashboard.learningStreaks.achievement40": "Forty days of wisdom",
  "dashboard.learningStreaks.achievement50": "Halfway to a hundred",
  "dashboard.learningStreaks.achievement60": "Two months of persistence",
  "dashboard.learningStreaks.achievement75": "Three-quarters of a century",
  "dashboard.learningStreaks.achievement90": "Three months of commitment",
  "dashboard.learningStreaks.achievement100": "Century of learning",
  "dashboard.learningStreaks.achievement120": "Four months, magic touch!",
  "dashboard.learningStreaks.achievement150": "150 days, a fortress of knowledge",
  "dashboard.learningStreaks.achievement180": "Half a year of enlightenment",
  "dashboard.learningStreaks.achievement200": "200 days, soaring high",
  "dashboard.learningStreaks.achievement250": "Quarter of a millennium!",
  "dashboard.learningStreaks.achievement300": "300 days, a shining example",

  "dashboard.learningStreaks.conversation1": "Getting started!",
  "dashboard.learningStreaks.conversation3": "Three chats already!",
  "dashboard.learningStreaks.conversation5": "Five conversations deep!",
  "dashboard.learningStreaks.conversation10": "Ten discussions, well done!",
  "dashboard.learningStreaks.conversation15": "15 conversations! Finding your rhythm!",
  "dashboard.learningStreaks.conversation16": "Finding your rhythm!",
  "dashboard.learningStreaks.conversation20": "20 deep dives into learning!",
  "dashboard.learningStreaks.conversation21": "Deep dives into learning!",
  "dashboard.learningStreaks.conversation30": "30 chats! The world is brighter!",
  "dashboard.learningStreaks.conversation31": "The world is brighter!",
  "dashboard.learningStreaks.conversation40": "40 conversations! Growing knowledge!",
  "dashboard.learningStreaks.conversation41": "Growing knowledge!",
  "dashboard.learningStreaks.conversation50": "Half a century of chats!",
  "dashboard.learningStreaks.conversation75": "75 enlightening talks!",
  "dashboard.learningStreaks.conversation100": "A hundred conversations! Truly committed!",
  "dashboard.learningStreaks.conversation150": "150 chats! A milestone of dedication!",
  "dashboard.learningStreaks.conversation200": "200 conversations! World-class communicator!",
  "dashboard.learningStreaks.conversation250": "250 chats! Master of dialogues!",
  "dashboard.learningStreaks.conversation300": "300 conversations! Future is bright!",
  "dashboard.learningStreaks.conversation400": "400 chats! Out of this world!",
  "dashboard.learningStreaks.conversation500": "500 conversations! Legendary!",
  "dashboard.learningStreaks.conversation750": "750 chats! Galaxy of knowledge!",
  "dashboard.learningStreaks.conversation1000": "1000 conversations! Kingdom of wisdom!",
  "dashboard.learningStreaks.conversation1500": "1500 discussions! Royalty of conversation!",
  "dashboard.learningStreaks.conversation2000": "2000 chats! Shooting star of dialogue!",

  "dashboard.aiTutors.title": "AI Tutors",
  "dashboard.aiTutors.description":
    " Your selected tutor will be waiting for you in the next chat session. Talk to you soon!",

  "dashboard.template.freeTalk.title": "New Session",
  "dashboard.template.freeTalk.description": "Talk about anything you want with your tutor",
  "dashboard.template.rolePlay.title": "Scenario",
  "dashboard.template.rolePlay.description":
    "Put yourself in different roles and act out the scenarios",
  "dashboard.template.topics.title": "Topic",
  "dashboard.template.topics.description": "Let's talk about a topic of your choice",
  "dashboard.template.caseStudy.title": "Case Discussion",
  "dashboard.template.caseStudy.description": "Discuss a case and answer questions about it",
  "dashboard.template.groupDiscussion.title": "Group Discussion",
  "dashboard.template.groupDiscussion.description": "Practice leaderless group discussions",
  "dashboard.template.quiz.title": "Quiz",
  "dashboard.template.quiz.description": "Practice words and sentences with engaging quizzes ",

  "dashboard.template.game.title": "Games",
  "dashboard.template.game.description": "Practice vocabulary with fun word games",

  "dashboard.template.modal.curated": "Curated",
  "dashboard.template.modal.custom": "Custom",
  "dashboard.template.modal.inputContent": "Input your own content",
  "dashboard.template.modal.noContent": "No content",
  "dashboard.template.recommended": "Recommended",

  "dashboard.conversations.description": "Your full list of conversations",

  "chat.index.failedConnection": "Unable to contact the server and send the message",
  "chat.index.audioFailedToSend": "Error sending audio message",
  "chat.index.usageCapMessageTrialTitle": "Wow, You're on a Roll!",
  "chat.index.usageCapMessageTrialText":
    "Looks like you've made the most out of your 7-day free trial - that's amazing! You've hit the character limit for this period. Eager to keep going right now? You can choose to upgrade your plan at any moment and pick up right where you left off.",
  "chat.index.usageCapMessageTrialFooterText":
    "We're here to support your journey, every step of the way.",
  "chat.index.usageCapMessagePlanTitle": "Heads Up!",
  "chat.index.usageCapMessagePlanText":
    "You have been enjoying all the features a lot this month, and we are thrilled! You have reached your usage limit for the current plan. To keep the experience seamless, consider taking a moment to review our plan options.",
  "chat.index.usageCapMessagePlanFooterText":
    "No rush though — your current plan will reset next month. Happy to have you with us!",
  "chat.index.visitAccount": "Visit Account",
  "chat.index.noMicTitle": "Microphone not allowed",
  "chat.index.noMicText": "Microphone access is blocked by your browser",

  "chat.asideMenu.voice": "Voice",
  "chat.asideMenu.text": "Text",
  "chat.asideMenu.newChat": "New Chat",
  "chat.asideMenu.pastConversations": "Past conversations",
  "chat.asideMenu.pastProgressConversations": "Conversation History & Progress", // eg. Progress Tracking and Conversation History
  "chat.asideMenu.noConversationsInLang": "No conversations in {language}",
  "chat.asideMenu.autoTranslate": "Auto Translate",
  "chat.asideMenu.showRomanization": "Show Romanization",
  "chat.asideMenu.multiLingualSpeech": "Multilingual Speech",
  "chat.asideMenu.endDemoNow": "End Demo Now",
  "chat.asideMenu.minutes": "min.",

  "chat.suggestions.titleSm": "Suggestion on what to say",
  "chat.suggestions.titleXs": "Suggestion",
  "chat.suggestions.regenerate": "Regenerate",
  "chat.suggestions.generating": "Generating...",
  "chat.suggestions.failed": "Failed to get suggestion. Please try to regenerate.",

  "chat.assistant.instructions": "To hear the message press ",

  "chat.conversation.tryAgain": "Go ahead and try again",
  "chat.conversation.cancel": "Cancel",

  "chat.speakInput.speak": "Speak",
  "chat.speakInput.recording": "Recording",
  "chat.speakInput.recordingHint": "Press to start talking!",

  "chat.textInput.sendMessage": "Send a message",

  "chat.autoSubmitSwitch.handsFree": "Hands-free",

  "chat.shortcuts.hold": "Hold",
  "chat.shortcuts.press": "Press",
  "chat.shortcuts.say": "Say",
  "chat.shortcuts.release": "Release",
  "chat.shortcuts.toRecord": "to record",
  "chat.shortcuts.toSend": "to send",
  "chat.shortcuts.toCancel": "to cancel",

  "chat.userMessageActions.speechPrecision": "Speech Precision",
  "chat.userMessageActions.speechPrecisionDescription":
    "Speech Precision indicates how confidently the tutor has interpreted your message. A higher percentage means greater accuracy in understanding what was said.",
  "chat.userMessageActions.speechPrecisionShowInfo": "Show Info",
  "chat.userMessageActions.speechPrecisionHideInfo": "Hide Info",
  "chat.userMessageActions.improveMyAnswer": "Improve My Answer",
  "chat.userMessageActions.retry": "Retry",

  "chat.feedbackMessageButton.improveMyAnswer": "Improve My Last Answer",
  "chat.feedbackMessageButton.feedbackOn": "Feedback on",
  "chat.feedbackMessageButton.speechPrecision": "Speech Precision",

  "chat.assessmentButton.title": "Conversation Assessment",
  "chat.assessmentButton.close": "Close",
  "chat.assessmentButton.analyzing": "Analyzing the entire conversation",
  "chat.assessmentButton.tooShort": "Conversation is too short to evaluate",

  "chat.languageMisMatchModal.title": "Language Mismatch",
  "chat.languageMisMatchModal.switchTo": "Yes, switch to {conversationPl}",
  "chat.languageMisMatchModal.keepCurrent": "No, keep my current setting",
  "chat.languageMisMatchModal.body":
    "Your practice language is set to {settingsPl}, but this conversation is in {conversationPl}. Would you like to switch your practice language to match the conversation?",

  "config.languageConfigPromptModal.title": "Select your practice language",
  "config.languageConfigPromptModal.body":
    "Your current practice language is not available in this organization. Please select an available practice language.",

  // Target vocabulary related translations
  "targetVocabulary.title": "Target Vocabulary", // name of feature where users get rewarded for saying certain words, in other languages this might translate better as 'words to speak', 'target words' or 'words to include'

  // Template presentation related translations
  "templatePresentation.startConversation": "Start Conversation",
  "templatePresentation.description": "Description",
  "templatePresentation.numberOfTurns": "Number of Turns",
  "templatePresentation.turns": "{count} turns",

  // Vocabulary assessment related translations
  "chat.assessmentButton.vocabularyFeedback.perfect":
    "Congratulations! You used every target word during your conversation!",
  "chat.assessmentButton.vocabularyFeedback.excellent":
    "Great job! You used a lot of the target words during your conversation! Try again to make sure you use them all!",
  "chat.assessmentButton.vocabularyFeedback.good":
    "Good job! You used most of the target words during your conversation. Try again to make sure you use them all!",
  "chat.assessmentButton.vocabularyFeedback.fair":
    "That's a good start! But you should try to use more target words during your conversation. Try again!",
  "chat.assessmentButton.vocabularyFeedback.poor":
    "Remember to try to use some of the target words during your conversations!",
  "chat.assessmentButton.vocabularyFeedback.stats": "{used} of {total} words used ({percentage}%)",

  // Vocabulary tips
  "vocabularyTips.sentenceLength": "Sentence Length",
  "vocabularyTips.sentenceLengthTip": "Use long sentences when possible.",
  "vocabularyTips.speakingPace": "Speaking Pace",
  "vocabularyTips.speakingPaceTip": "Speak naturally, but avoid rushing.",
  "vocabularyTips.pronunciationFocus": "Pronunciation Focus",
  "vocabularyTips.pronunciationFocusTip": "Pronounce difficult words clearly.",
  "vocabularyTips.grammarAccuracy": "Grammar",
  "vocabularyTips.grammarAccuracyTip": "Pay attention to verb tenses and sentence structures.",
  "vocabularyTips.useSynonyms": "Use Synonyms",
  "vocabularyTips.useSynonymsTip": "Avoid repeating the same words; try alternatives.",
  "vocabularyTips.contextAwareness": "Context Awareness",
  "vocabularyTips.contextAwarenessTip": "Adapt your response based on the conversation topic.",
  "vocabularyTips.intonationPractice": "Intonation Practice",
  "vocabularyTips.intonationPracticeTip": "Vary your tone to sound more natural.",
  "vocabularyTips.questionFormation": "Question Formation",
  "vocabularyTips.questionFormationTip":
    "Use different types of questions (open, yes/no, follow-up).",
  "vocabularyTips.confidenceBuilding": "Confidence Building",
  "vocabularyTips.confidenceBuildingTip": "Speak with confidence, even if you make mistakes.",
  "vocabularyTips.errorAwareness": "Error Awareness",
  "vocabularyTips.errorAwarenessTip": "Notice and correct mistakes where possible.",
  "vocabularyTips.vocabularyExpansion": "Vocabulary Expansion",
  "vocabularyTips.vocabularyExpansionTip": "Try to incorporate newly learned words into responses.",
  "vocabularyTips.conversationalFlow": "Conversational Flow",
  "vocabularyTips.conversationalFlowTip": "Respond naturally and avoid robotic replies.",
  "vocabularyTips.listenBeforeSpeaking": "Listen Before Speaking",
  "vocabularyTips.listenBeforeSpeakingTip":
    "Listen and pay attention before formulating your response.",
  "vocabularyTips.engageInSmallTalk": "Engage in Small Talk",
  "vocabularyTips.engageInSmallTalkTip": "Start with light conversation before deeper topics.",
  "vocabularyTips.useExamples": "Use Examples",
  "vocabularyTips.useExamplesTip": "Support sentences with examples to communicate more clearly.",
  "vocabularyTips.stayOnTopic": "Stay on Topic",
  "vocabularyTips.stayOnTopicTip": "Keep your answers relevant to the conversation's theme.",
  "vocabularyTips.expressOpinions": "Express Your Opinion",
  "vocabularyTips.expressOpinionsTip":
    "Use phrases like 'I think', 'In my opinion', or 'I believe.'",

  // Vocabulary notification messages
  "vocabularyNotification.title1": "Nice! You hit the target!",
  "vocabularyNotification.title2": "Great progress!",
  "vocabularyNotification.title3": "Amazing!",
  "vocabularyNotification.title4": "Well done!",
  "vocabularyNotification.title5": "Fantastic!",
  "vocabularyNotification.title6": "Keep going!",
  "vocabularyNotification.title7": "You're doing great!",
  "vocabularyNotification.title8": "Well played!",
  "vocabularyNotification.title9": "Super!",
  "vocabularyNotification.description": "You said {words}",
  "email.invitation.greeting": "Hello!",
  "email.invitation.acceptButton": "Accept Invitation",
  "email.invitation.recipientInfo": "This email was sent to {email}",

  "email.invitation.newUser.title": "You have been invited to join {serviceName}",
  "email.invitation.newUser.intro":
    "We're excited to let you know that you've been invited to join {serviceName}.",
  "email.invitation.newUser.userDetailsIntro":
    "We have created a user for you with the following details:",
  "email.invitation.newUser.emailLabel": "Email address: {email}",
  "email.invitation.newUser.passwordLabel": "Password: {password}",
  "email.invitation.newUser.changePasswordRecommendation":
    "We recommend changing the password as soon as possible.",
  "email.invitation.newUser.callToAction":
    "Please click the button to accept your invitation and get started.",
  "email.invitation.newUser.closingRemark": "We look forward to welcoming you!",
  "email.invitation.existingUser.intro":
    "We're excited to let you know that you've been invited to join {serviceName}.",
  "email.invitation.existingUser.callToAction":
    "It seems you already have an account linked to this email. Please click the button below and use <strong>your current login credentials</strong> to accept the invitation.",
  "email.invitation.existingUser.forgotPasswordPrompt":
    "If you can't remember your password then please {link}.",
  "email.invitation.existingUser.forgotPasswordLinkText": "create a new one here",

  "email.invitation.newUser.subject": "You have been invited to join {serviceName}",
  "email.invitation.existingUser.subject": "You have been invited to join {serviceName}",

  "settings.title": "Settings",
  "settings.subtitle": "Customize your experience with the tutor.",
  "settings.language": "Language",
  "settings.yourLanguage": "Your Language",
  "settings.uiLanguage": "UI Language",
  "settings.practiceLanguage": "Practice Language",
  "settings.proficiency": "proficiency",
  "settings.tutor": "Tutor",
  "settings.name": "Name",
  "settings.talkingSpeed": "Talking speed",
  "settings.speechInput": "Speech Input",
  "settings.autoPunctuation": "Automatic Punctuation",
  "settings.autoPunctuationDescription": "Automatically add punctuation when you pause",
  "settings.multiLingualSpeechRecognition": "Multilingual Speech Recognition",
  "settings.multiLingualSpeechRecognitionDescription":
    "The tutor will recognize speech in both the practice language and your native language",
  "settings.handsFree": "Hands-free chat mode",
  "settings.handsFreeDescription":
    "Talk without needing to click the microphone button. Your message will be sent automatically when silence is detected",
  "settings.submitWithTriggerWord": "Submit using trigger word",
  "settings.submitWithTriggerWordDescription":
    "Use a trigger word to submit your message instead of silence detection",
  "settings.triggerWord": "Trigger Word",
  "settings.triggerWordDescription":
    "Pick a word that is simple to pronounce in your practice language",
  "settings.translations": "Translations",
  "settings.autoTranslate": "Auto Translate",
  "settings.autoTranslateDescription":
    "Automatically translate messages from the tutor to your native language",
  "settings.showRomanization": "Show Romanization",
  "settings.showRomanizationDescription":
    "Show romanization of the latest chat message for script languages",
  "settings.audio": "Audio",
  "settings.playbackUiAudio": "Enable UI audio",
  "settings.playbackUiAudioDescription": "Enable audio feedback for UI interactions",
  "settings.autoPlayTutorResponse": "Auto-play tutor responses",
  "settings.autoPlayTutorResponseDescription": "Automatically play tutor responses aloud",
  "settings.picture": "Profile",
  "settings.profileImage": "Profile Image",
  "settings.uploadImage": "Upload Image",
  "settings.imageRequirements": "Maximum file size: 1MB",
  "settings.nickname": "Nickname",
  "settings.enterNickname": "Enter your nickname",
  "settings.save": "Save",
  "success.profileImageUpdated": "Profile image updated",

  "success.nicknameUpdated": "Nickname updated",
  "error.fileTooLarge": "File too large",
  "error.maxFileSize": "Maximum file size is 1MB",
  "error.uploadFailed": "Upload failed",
  "error.fileTypeNotSupported": "File type not supported",
  "error.updateFailed": "Update failed",
  "error.nicknameRequired": "Nickname cannot be empty",
  "wordbook.title": "Wordbook",
  "wordbook.subtitle":
    "Track the words you learn; your tutor will help you use them to boost your memory",
  "wordbook.noWord": " No words saved for the chosen language",
  "wordbook.yourPracticeLanguage": "Your practice language",
  "wordbook.word": "Word",
  "wordbook.addToWordbook": "Add to Wordbook",
  "wordbook.pleaseEnterIn": "Please enter a word in",
  "wordbook.selectWord": "Select a word",

  "flashcard.flashcards.title": "Flashcard",
  "flashcard.flashcards.untitled": "Untitled",
  "flashcard.flashcards.subtitle":
    "Flip the flashcards, listen to pronunciations, and test your understanding of each word",
  "flashcard.flashcards.empty":
    " The Flashcard collection may not exist, or there are no Wordbook items included in this Flashcard collection. Please return to the Wordbook to set up a flashcard",
  "flashcard.flashCards": "Flashcards",
  "flashcard.flashCardsTitle": "Flashcards",
  "flashcard.flashCardsInstructions":
    "Turn your wordbook into Flashcards and practice their meaning",
  "flashcard.pickXRandom": "Pick x random words from the wordbook and turn them into Flashcards",
  "flashcard.pickXRandom.failed":
    "Failed to get random wordbook items to include in the flashcard.",
  "flashcard.pickXRandomTitle": "Number of random words",
  "flashcard.pickXRandomInstructions":
    "Specify desired number of random words from the wordbook and turn them into Flashcards",
  "flashcard.wordbookCount": "Wordbook count",
  "flashcard.pickManual": "Select words from the wordbook to practice",
  "flashcard.pickManualTitle": "Select words",
  "flashcard.pickManualInstructions": "Select words and turn them into flashcards",
  "flashcard.savedCollection.title": "Saved Collections",
  "flashcard.savedCollection.empty": "No saved flashcard collection.",
  "flashcard.savedCollection.words": "words",
  "flashcard.container.done": "Congratulations!",
  "flashcard.container.youComplete": "You've completed the flashcards!",
  "flashcard.saveCollection.title": "Save Collection",
  "flashcard.saveCollection.label": "Title",
  "flashcard.editCollection.title": "Edit Collection",
  "flashcard.editCollection.label": "Change Title",

  "pronunciation.title": "Pronunciation",
  "pronunciation.subtitle": "Practice pronunciation and fluency",
  "pronunciation.intro":
    "The tutor will generate suitable sentences, tailored to your proficiency level, which is set to",
  "pronunciation.startPracticing": "Start practicing",
  "pronunciation.done": "Done",
  "pronunciation.cancel": "Cancel",
  "pronunciation.tryAgain": "Please try again",
  "pronunciation.wordByWord.loading": "Loading...",
  "pronunciation.wordByWord.stopReading": "Stop reading",
  "pronunciation.wordByWord.readSentence": "Read sentence",
  "pronunciation.wordByWord.newSentence": "New sentence",
  "pronunciation.wordByWord.retrySentence": "Retry sentence",
  "pronunciation.saveProgress.progressSaved": "Analyzing your pronunciation",
  "pronunciation.saveProgress.progressNotSaved":
    "Unable to save your pronunciation progress. Please check your connection and try again.",
  "pronunciation.saveProgress.saveProgress":
    "Save sentence and score to track progress and retry later.",
  "pronunciation.saveProgress.saved": "Auto Saving",
  "pronunciation.saveProgress.saveSentenceAndAssessment": "Save sentence & assessment",
  "pronunciation.assessmentStats.noResults": "No result to show",
  "pronunciation.assessmentStats.pronunciation": "Pronunciation",
  "pronunciation.assessmentStats.pronunciationScore": "Pronunciation score",
  "pronunciation.assessmentStats.pronunciationDescription":
    "The Pronunciation Score represents the quality of pronunciation in the given speech. It is calculated by combining Accuracy Score, Fluency Score, and Completeness Score, each assigned with a specific weight.",
  "pronunciation.assessmentStats.accuracy": "Accuracy",
  "pronunciation.assessmentStats.accuracyScore": "Pronunciation accuracy",
  "pronunciation.assessmentStats.accuracyDescription":
    "Pronunciation accuracy measures how well spoken words match those of a native speaker. Accuracy scores for syllables, words, and full text are based on phoneme-level accuracy and adjusted according to assessment goals.",
  "pronunciation.assessmentStats.completeness": "Completeness",
  "pronunciation.assessmentStats.completenessScore": "Completeness",
  "pronunciation.assessmentStats.completenessDescription":
    "Completeness of speech is determined by comparing the number of words pronounced to the total number of words in the reference text.",
  "pronunciation.assessmentStats.fluency": "Fluency",
  "pronunciation.assessmentStats.fluencyScore": "Fluency",
  "pronunciation.assessmentStats.fluencyDescription":
    "Fluency of the given speech. Fluency indicates how closely the speech matches a native speaker's use of silent breaks between words.",
  "pronunciation.assessmentStats.keepPracticing": "Keep practicing!",
  "pronunciation.assessmentStats.makingProgress": "Making progress!",
  "pronunciation.assessmentStats.wellDone": "Well done!",
  "pronunciation.assessmentStats.almostThere": "Almost there!",
  "pronunciation.assessmentStats.excellentJob": "Excellent job!",
  "pronunciation.history.saveAssessments": "Previous Assessments",
  "pronunciation.history.noAssessments": "No assessments yet",
  "pronunciation.history.score": "Score",
  "pronunciation.history.tryAgain": "Try again",
  "pronunciation.history.view": "View",
  "pronunciation.retries.title": "Pronunciation Retries",
  "pronunciation.retries.noRetries": "No retries yet",
  "pronunciation.viewResult.title": "Pronunciation Assessment Result",
  "pronunciation.viewResult.subtitle": "View the result and retry the pronunciation assessment",
  "pronunciation.viewResult.error": "Unable to load the saved assessment",
  "pronunciation.viewResult.reload": "Reload",
  "account.unableToLoad": "Unable to load user details",
  "account.title": "Account",
  "account.renewFailed": "Subscription failed to renew",
  "account.reviewPaymentDetails": "Please review your payment details",
  "account.subscriptionInactive": "Subscription inactive",
  "account.subscriptionManagementPage": "subscription management page",
  "account.questionContactUs":
    "If you have any questions or comments do not hesitate to contact us at",
  "account.billing": "Billing",
  "account.plan": "Plan",
  "account.amount": "Amount",
  "account.usage": "Usage",
  "account.usageDescription":
    "The usage limit is determined by the total number of characters involved in conversations, which includes both the text input sent to the AI and the text generated by the AI in response. This limit is reset on a monthly basis. {limit} characters are roughly equivalent to {estHours} hours of conversation.",
  "account.requestRefund": "Request refund",
  "account.manageSubscription": "Change or Cancel Subscription",
  "account.updateOrganizationSubscription":
    "If you need to update or cancel your membership, please contact us at {email}",
  "account.subscriptionManagedByPartner": "Your subscription is managed by",
  "account.contactPartner":
    "Please reach out to {userPlanId} to change or cancel your subscription.",
  "account.accessSubscriptionManagement":
    "On the subscription management page, you can update your billing information, change your subscription plan, or cancel your subscription.",
  "account.goToSubscriptionManagement": "Go to subscription management",
  "account.feedbackAndSupport": "Feedback & Support",
  "account.discordDescription":
    "Your feedback is invaluable to us! Share your thoughts, suggest improvements, and get support from our team and community on Discord:",
  "account.discordLinkText": "Join the community on Discord",
  "account.feedbackCallToAction": "share your thoughts",
  "account.reviewDescription": "If you're enjoying the app, we'd be grateful for",
  "account.reviewCallToAction": "your review!",
  "account.signOutDescription":
    "Sign out of your account or change your password using the buttons below.",
  "account.changePassword": "Change Password",
  "account.changePreferredOrganization": "Change Preferred Organization",
  "account.changePreferredOrganizationDescription":
    "Since your account is connected to organizations, you can set your preferred organization below.",
  "account.userEmail": "User",
  "account.connection": "Connection",
  "intro.title": "Welcome to {serviceName}",
  "intro.subtitle": "Let's get you started with a few questions",
  "intro.userLanguageTitle": "Language",
  "intro.userLanguageSubtitle": "What is your native language?",
  "intro.practiceLanguageTitle": "Language",
  "intro.practiceLanguageSubtitle": "What language do you want to practice?",
  "intro.proficiencyTitle": "Proficiency",
  "intro.proficiencyDescription": "What's your proficiency in {practiceLanguage}",
  "intro.completionModal.title": "You are all set!",
  "intro.completionModal.buttonText": "Time to start talking",

  "hooks.useConversation.noSpeech": "Speech not detected or volume too low",
  "hooks.useAssessment.unableToFetchPinyin": "Unable to fetch pinyin",
  "hooks.useAssessment.unableToCreateSpeechRecognizer":
    "Unable to connect to the pronunciation assessment server",
  "hooks.useAssessment.unableToFetchAssessment":
    "Unable to fetch the assessment. Please try again later.",
  "hooks.useAssessment.noSpeech": "No speech detected",
  "hooks.useAssessment.retryError": "Error",
  "hooks.useAssessment.retryErrorDescription": "Unable to load the saved assessment",
  "hooks.useAssessment.retryErrorDescriptionForNewRetryProgress": "Unable to save the progress",

  "hooks.useWordbook.deleteConfirm": "Are you sure you want to delete this word?",
  "hooks.useWordbook.unableToDeleteWord":
    "Unable to delete word. Please try again in a few seconds.",

  "components.miniTranslator.translate": "Translate",
  "components.miniTranslator.to": "to",

  "components.conversationDownloadModal.user": "User",
  "components.conversationDownloadModal.tutor": "Tutor",
  "components.conversationDownloadButton.export": "Export Chat",

  "components.conversationDeleteButton.export": "Delete Chat",

  "components.micPermissionButton.notAllowed": "Microphone access not allowed",
  "components.micPermissionButton.turnOnMicAndSound": "Turn on microphone & sound",
  "components.micPermissionButton.pleaseAllow": "Please allow microphone access",

  "components.languageSelector.managedByOrganization": "Managed by organization",

  "components.languageSelector.selectLanguage": "Select Language",
  "components.languageSelector.fullList": "Show full list",
  "components.languageSelector.simpleList": "Show simplified list",

  "components.proficiencySelector.helpMeChoose": "Help me choose",
  "components.proficiencySelector.descriptionsTitle": "Proficiency descriptions",
  "components.proficiencySelector.descriptionsSubtitle":
    "Here are descriptions of the different language proficiency levels.",
  "components.proficiencySelector.beginnerLabel": "Beginner",
  "components.proficiencySelector.beginnerDescription":
    "The individual can use basic expressions to meet practical needs with clear communication and willingness from others.",
  "components.proficiencySelector.elementaryLabel": "Elementary",
  "components.proficiencySelector.elementaryDescription":
    "The individual understands important topics, communicates effectively in routine matters, and can explain their background and necessities.",
  "components.proficiencySelector.intermediateLabel": "Intermediate",
  "components.proficiencySelector.intermediateDescription":
    "The individual understands and communicates basic information on common subjects, manages travel situations, and expresses personal experiences, opinions, and plans.",
  "components.proficiencySelector.upperIntermediateLabel": "Upper-Intermediate",
  "components.proficiencySelector.upperIntermediateDescription":
    "The individual understands complex practical and theoretical text, communicates fluently with native speakers, generates comprehensive text, and expresses their perspective on current issues.",
  "components.proficiencySelector.advancedLabel": "Advanced",
  "components.proficiencySelector.advancedDescription":
    "The individual comprehends complex texts with implicit meaning, communicates fluently and proficiently, and generates well-constructed and coherent text on complicated topics.",
  "components.proficiencySelector.close": "Close",

  "components.readSpeedSlider.speed": "Speed",
  "components.readSpeedSlider.verySlow": "Very slow",
  "components.readSpeedSlider.slow": "Slow",
  "components.readSpeedSlider.normal": "Normal",
  "components.readSpeedSlider.fast": "Fast",
  "components.readSpeedSlider.veryFast": "Very fast",

  "components.speechRecognitionSelector.voiceInputEngine": "Voice Input Engine",
  "components.speechRecognitionSelector.default": "Standard",
  "components.speechRecognitionSelector.alternative": "Precision",

  "components.saveWord.save": "Save",
  "components.saveWord.notUnderstood": "The AI did not understand this word. Please try again.",
  "components.saveWord.failed": "Failed to save. Please try again.",
  "components.saveWord.savedToWordbook": "saved to your wordbook ",

  "components.setupFlashcards.failed": "Save 3 wordbook words to enable",
  "components.setupFlashcards.empty":
    "No Wordbook item selected. Please go back to Wordbook and setup a flashcard.",
  "components.setupFlashcards.backToWordbook": "Go back to Wordbook",
  "components.setupFlashcards.invalid":
    "The number of words specified is more than the total wordbook items.",
  "components.setupFlashcards.radom.start": "Start",
  "components.setupFlashcards.manual.start": "Start",
  "components.setupFlashcards.manual.launch": "Launching Flashcard...",
  "components.setupFlashcards.random.launch": "Launching Flashcard...",
  "components.flashcards.failed": "Maximum words reached.",
  "components.flashcards.retry": "Retry",
  "components.flashcards.backToWordbook": "Go back to Wordbook",
  "components.flashcards.util.gethint": "Get a hint",
  "components.flashcards.util.hintStartsWith": "The word starts with",
  "components.flashcards.util.flip": "Click to flip",
  "components.saveFlashcard.save": "Save Collection",
  "components.saveFlashcard.noSelected": "No flashcards selected.",
  "components.saveFlashcard.invalidTitle": "Please provide a Flashcard collection title.",
  "components.saveFlashcard.success": "Flashcard collection was saved!",
  "components.saveFlashcard.failed": "Failed to save the collection.",
  "components.saveFlashcard.submit": "Save",
  "components.saveFlashcard.deleteConfirm":
    "Are you sure you want to remove this Flashcard collection?",
  "components.saveFlashcard.delete.failed": "Failed to delete the Flashcard collection",
  "components.saveFlashcard.delete.success": "Flashcard collection was deleted",
  "components.editFlashcard.submit": "Save Changes",
  "components.editFlashcard.edit": "Edit",
  "components.editFlashcard.remove": "Remove",
  "components.editFlashcard.invalidTitle": "Please provide a Flashcard collection title.",
  "components.editFlashcard.success": "Flashcard collection was updated successfully!",
  "components.editFlashcard.failed": "Failed to update the flashcard collection.",

  "components.wordInformation.content.description": "Description",
  "components.wordInformation.content.sentences": "Sentences",

  "components.textWithActions.readAloud": "Read aloud",
  "components.textWithActions.saveWord": "Save word",
  "components.textWithActions.learnMore": "Learn more",

  "components.pwaPromptIos.title": "Install {app} on your device",
  "components.pwaPromptIos.step1": " Tap the Share icon",
  "components.pwaPromptIos.step2": "Select 'Add to Home Screen'",
  "components.pwaPromptIos.step3": "No App Store needed!",
  "components.pwaPromptAndroid.title": "Install App",

  "components.organizationSwitcher.save.success": "The preferred organization was updated.",
  "components.organizationSwitcher.save.failed": "Failed to save preferred organization.",
  "components.organizationSwitcher.save.unexpectedError": "An unexpected error occurred.",

  "components.categoryTemplates.more": "More",
  "components.categoryTemplates.moreDescription": "Even More to Talk About",

  "components.categoryModal.searchAriaLabel": "Search templates",
  "components.categoryModal.searchPlaceholder": "Search by title or description...",

  "guide.title": "Interactive Guides",
  "guide.subtitle": "Quiz-style guides to help you learn the language",
  "guide.disclaimerFirst":
    "The guide is partially generated with AI and we continuously quality check.",
  "guide.disclaimerLinkText": "Please let us know",
  "guide.disclaimerLast": "if you find any errors or omissions.",
  "guide.welcome.title": "Language Guide",
  "guide.welcome.errorMessage": "Hmm... looks like an error occurred",
  "guide.welcome.errorHelp": "Please refresh and try again in a few moments.",
  "guide.welcome.setupMessage": "Please check back a little later while we prepare the guide.",
  "guide.welcome.setupHelp":
    "Looks like we don't have this language combination yet. Come back a little later and we'll have it ready for you.",
  "guide.completion.title": "Well done!",
  "guide.completion.subtitle": "You completed the guide",
  "guide.completion.goToDashboard": "Go to Dashboard",
  "guide.completion.tryAgain": "Try again",
  "guide.step.examples": "Examples",
  "guide.retry": "Retry",

  "guide.beginnerIntro.title": "Beginner Introduction",
  "guide.beginnerIntro.shortText": "Begin your journey by mastering the basics of the language",
  "guide.beginnerIntro.longText":
    "Begin your journey by mastering the basics of the language. Our interactive quiz-style guide covers foundational elements to get you ready for your first conversation.",

  "guide.beginnerCounting.title": "Introduction to Numbers and Counting",
  "guide.beginnerCounting.shortText":
    "Dive into our three-step guide to mastering numbers in your new language",
  "guide.beginnerCounting.longText":
    "Dive into our three-step guide to mastering numbers in your new language. Begin with basic numbers 1-10, then practice counting objects, and finally, apply your skills in everyday scenarios like shopping and telling time. This interactive quiz reinforces your learning with practical exercises and multiple-choice questions, perfect for beginners aiming for fluency in everyday numerical conversations.",

  "guide.beginnerCommonVerbs.title": "Common Verbs",
  "guide.beginnerCommonVerbs.shortText": "A four-step quiz-style guide on common verbs",
  "guide.beginnerCommonVerbs.longText":
    "Start your journey to language mastery with our four-step beginner quiz on common verbs. This interactive guide begins by identifying and using essential verbs. Advance through forming simple sentences, applying verbs in daily actions, and crafting questions. Each step includes practical examples and exercises to solidify your understanding and usage of verbs in your new language.",

  "progress.title": "Progress",
  "progress.subtitle": "Track your learning journey for {languageName}",
  "progress.activityCalendar.feedbackNewUser":
    "Welcome! You've just started your language learning journey. Keep up the good work!",
  "progress.activityCalendar.feedbackGood":
    "Great job! You've completed {percentage}% of the days this month. Keep up the momentum!",
  "progress.activityCalendar.feedbackMediocre":
    "You're making progress! You've completed {percentage}% of the days this month. Keep going, every bit counts!",
  "progress.activityCalendar.feedbackBad":
    "Don't give up! You've completed {percentage}% of the days this month. It's never too late to turn things around and make the rest of the month count!",

  "progress.history.title": "History", // e.g. "Progress History"
  "progress.history.empty": "No activity",
  "progress.scores.timeSpent": "Time spent this month",
  "progress.scores.currentStreak": "Current streak",
  "progress.scores.longestStreak": "Longest streak",
  "progress.scores.wordsSaved": "Words saved",
  "progress.scores.pronunciationCount": "Pronunciation exercises",

  "progress.weekly.title": "Weekly Assessment",
  "progress.weekly.welcomeTitle": "Results are processed weekly",
  "progress.weekly.welcomeDescription":
    "Start practicing this week! Each Monday, we'll share a summary of your progress from the previous week with personalized feedback.",
  "progress.weekly.noPractice": "No activity for this period",
  "progress.weekly.error":
    "The tutor is currently unable to provide feedback. Please try again later.",
  "progress.weekly.noFeedback": "No feedback available",
  "progress.weekly.pronunciationLabel": "Pronunciation",
  "progress.weekly.conclusionLabel": "Conclusion",
  "progress.weekly.currentProficiency": "Current proficiency",
  "progress.weekly.suggestedProficiency": "Suggested proficiency",
  "progress.weekly.changeProficiency": "Change Proficiency",

  "chat.userMessage.perfectSentence1": "Great sentence! Keep it up!",
  "chat.userMessage.perfectSentence2": "Great job!",
  "chat.userMessage.perfectSentence3": "Well done!",

  "settings.liveFeedback": "Instant Feedback",
  "settings.liveFeedbackDescription":
    "Displays feedback on how to improve your answer after each message.",

  "dashboard.template.dailySession.title": "Daily Session",
  "dashboard.template.dailySession.with": "with {tutorName}", // short version of Daily Session with {tutorName}, {tutorName} is a dynamic placeholder don't translate
  "dashboard.template.dailySession.description":
    "Join today's conversation to practice and enhance your language skills",
  "dashboard.template.dailySession.button": "Begin Daily Session",

  "feedbackCard.loader.analyzeGrammar": "Analyzing grammar...",
  "feedbackCard.loader.analyzeVocabulary": "Analyzing vocabulary...",
  "feedbackCard.loader.analyzeStructure": "Analyzing sentence structure...",
  "feedbackCard.error.message":
    "We are sorry, but we encountered an issue while processing your feedback. Please refresh to try again.",
  "feedbackCard.improvedAnswerLabel": "Improved Answer",
  "feedbackCard.grammarLabel": "Grammar",
  "feedbackCard.vocabularyLabel": "Vocabulary",
  "feedbackCard.structureLabel": "Structure", // e.g. sentence structure

  "chat.completionMessage.title": " Great job! You have successfully completed the scenario!",
  "chat.completionMessage.description":
    "Feel free to continue the conversation or explore another scenario.",

  "components.micPermissionAlert.helpButton": "Help me fix it",
  "components.micPermissionAlert.troubleshootingTitle": "Troubleshooting Microphone Issues",
  "components.micPermissionAlert.troubleshootingIntro":
    "If you're experiencing problems with your microphone, try the following common solutions:",
  "components.micPermissionAlert.allowAccessTitle": "Allow Microphone Access",
  "components.micPermissionAlert.allowAccessText":
    "Make sure your browser has permission to use your microphone: Click the padlock icon next to the browser's address bar. Ensure microphone access is set to Allow.",
  "components.micPermissionAlert.inputDeviceTitle": "Set the Correct Input Device",
  "components.micPermissionAlert.inputDeviceText":
    "Check that your microphone is selected as the default recording device on your computer. On Windows: Settings → System → Sound. On macOS: System Settings → Sound → Input.",
  "components.micPermissionAlert.unmuteTitle": "Unmute Your Microphone",
  "components.micPermissionAlert.unmuteText":
    "Ensure your microphone isn't muted. Check your computer or phone settings. If you're using a headset or external mic, verify the mute switch is off.",
  "components.micPermissionAlert.bluetoothTitle": "Check Bluetooth Connections",
  "components.micPermissionAlert.bluetoothText":
    "Your device may be connected to another pair of Bluetooth headphones or microphones. Disconnect or switch devices if needed.",
};

export default l;
